
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from '@cmsgov/design-system';



const DropdownAdapter = props => {

    const {
        value: receivedValue,
        options: receivedOptions,
        ...restProps
    } = props;

    const intlApi = useIntl();

    const adjustedProps = useMemo(
        () => {
            const getCorrectValue = value => {
                switch(true) {
                    case value === true:
                        return 'true';
                    case value === false:
                        return 'false';
                    case value === null:
                        return 'null';
                    case typeof value === 'string' && value.includes('search.dropdown.option.label'):
                        return intlApi.formatMessage({ id: value });
                    default:
                        return value;
                }
            };

            const value = getCorrectValue(receivedValue);

            const options = receivedOptions.map(option => {
                return Object.entries(option).reduce((res, [ key, value ]) => {
                    return {
                        ...res,
                        [ key ]: getCorrectValue(value)
                    };
                }, { });
            });

            return {  value, options };
        },
        [ receivedValue, receivedOptions ]
    );

    return (
        <Dropdown { ...restProps } { ...adjustedProps } />
    );
};

export default DropdownAdapter;